import { useTranslation } from "react-i18next";

/**
 * On the customer's parcel card when we marked it damaged or lost: what
 * happened, that transport is not charged, and any money that came back.
 */
const ParcelIncidentBadge = ({ incident }) => {
  const { t } = useTranslation();
  if (!incident) return null;
  const lost = incident.type === "lost";
  const refund = Number(incident.transport_refund || 0);
  const comp = Number(incident.compensation || 0);

  return (
    <div
      className={`mt-1 rounded-lg px-2.5 py-1.5 text-xs leading-snug border ${
        lost
          ? "bg-red-50 border-red-200 text-red-800 dark:bg-red-900/30 dark:border-red-800 dark:text-red-200"
          : "bg-orange-50 border-orange-200 text-orange-800 dark:bg-orange-900/30 dark:border-orange-800 dark:text-orange-200"
      }`}
    >
      <p className="font-bold">
        {lost ? "⛔ " : "⚠ "}
        {lost ? t("incident_lost") : t("incident_damaged")}
        {incident.reason ? ` — ${incident.reason}` : ""}
      </p>
      <p>{t("incident_no_transport")}</p>
      {refund > 0 && (
        <p>
          {t(incident.refund_to === "points" ? "incident_refunded_points" : "incident_refunded_balance", {
            amount: refund.toFixed(2),
          })}
        </p>
      )}
      {comp > 0 && <p>{t("incident_compensated", { amount: comp.toFixed(2) })}</p>}
    </div>
  );
};

export default ParcelIncidentBadge;
